/* jslint esnext: true */

"use strict";
var src$core$$ = require("./core"), src$en$$ = require("./en");

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/intl-messageformat/lib/main.js
 ** module id = 1132
 ** module chunks = 0
 **/